//  @flow
import * as React from "react";
import { useState } from "react";

import {
  Box, Typography,
} from "@mui/material";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


import "./styles.scss";
import UserOfferList from "components/pages/user/offers/UserOfferList";
import UserShopList from "components/pages/user/favourites/UserShopList";
import UserWishList from "components/pages/user/favourites/UserWishList";
import {isLocalMarket} from "helpers/utils";
import MarketHeaderMini from "components/elements/main/MarketHeaderMini";

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const UserFavs = (props) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
        {isLocalMarket() && <MarketHeaderMini />}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value}
              onChange={handleChange}
              variant="fullWidth"
              aria-label="">
          <Tab label="Deals" {...a11yProps(0)} />
          <Tab label={`Fav ${process.env.REACT_APP_SHOP_TITLE}`}  {...a11yProps(1)} />
          <Tab label={`Fav ${process.env.REACT_APP_PRODUCT_TAG}`}  {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <br />
        <UserOfferList {...props} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <br />
        <UserShopList {...props} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <br />
        <UserWishList {...props} />
      </TabPanel>
    </Box>
  );
};

export default (UserFavs);
